import { render, staticRenderFns } from "./VacancyStat.vue?vue&type=template&id=2b1c3711&"
import script from "./VacancyStat.vue?vue&type=script&lang=js&"
export * from "./VacancyStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports